export const DEFAULT_LOCALE = "en"
export const INTERNATIONAL_LOCALES = ["de"]
export const LOCALES = [DEFAULT_LOCALE, ...INTERNATIONAL_LOCALES]
